/* eslint-disable react-hooks/exhaustive-deps */
import { makeStyles } from '@material-ui/core';
import React from 'react';
import clsx from 'clsx';
import styles from './styles';

const useStyles = makeStyles(styles);

interface Props {
  value: number | null;
  isEnv?: boolean;
}

const PercentIndicator = ({ value, isEnv }: Props) => {
  const classes = useStyles();

  const clamp = (n?: number | string | null) =>
    Math.max(0, Math.min(100, Number(n ?? 0)));

  const usePercentColor = (
    value: number,
    classes: ReturnType<typeof useStyles>
  ) => {
    if (value >= 90) return classes.indicatorRed;
    if (value > 49) return classes.indicatorYellow;
    return classes.indicatorGreen;
  };

  const v = clamp(value);
  const colorClass = usePercentColor(v, classes);

  const isCritical = Number(value ?? 0) >= 100;

  return (
    <div
      className={clsx(classes.indicatorRow, {
        [classes.indicatorRowEnv]: isEnv,
      })}
      title={`${v}%`}
    >
      <div
        className={clsx(classes.indicatorTrack, {
          [classes.indicatorTrackEnv]: isEnv,
        })}
      >
        <div
          className={`${classes.indicatorBar} ${colorClass}`}
          style={{ width: `${v}%` }}
        />
      </div>
      <span
        className={clsx(classes.indicatorLabel, {
          [classes.indicatorLabelRed]: isCritical,
        })}
      >
        {v}%
      </span>
    </div>
  );
};

export default PercentIndicator;
